import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
import moment from 'moment';
import {
    InfoMainContainer,
    InfoItems,
    InfoItemsTitle,
    InfoItemsValue,
} from './PatientInformation.styled';
import edit from 'src/assets/images/Edit.svg';
import { isMobileView } from 'src/utils/util';
import { useTranslation } from 'react-i18next';
import { VISIBLE } from 'src/constants/appConstants';
import { getDisplayDate } from 'src/utils/dateUtils';
import { COUNTRY_CODE_JAPN } from 'src/constants/productConstants';
import DownArrowFilter from 'src/assets/images/DownArrowFilter.svg';
import { CollapsableCardImageContainer } from 'src/styles/CommonStyles.styled';
import { SMALL_TEXT_PX } from '../../../../styles/fonts/MCFontConstants';

const PatientInformation = ({
    navigateToSpecifiedScreen,
    showEditButton,
    reviewScreen,
    title,
    fromReportPayment,
}) => {
    const { t } = useTranslation();
    const [expandedCard, setExpandedCard] = useState({
        patient: fromReportPayment ? false : true,
    });
    const {
        patientInformationVisibility,
        patientIdVisibility,
        reportUsagePatientDetails,
    } = useSelector((state) => state.loginReducer);
    const countryCode = localStorage.getItem('countryISOCode');

    const { patient } = expandedCard;
    const toggleCard = (name, value) => {
        setExpandedCard({
            ...expandedCard,
            [name]: value,
        });
    };

    // const getUserrdetails = useSelector(
    //     (state) => state.reportUsageRootReducer.patientDetails
    // );

    const storedPatientDetails = useSelector(
        (state) => state.reportUsageRootReducer.storedPatientDetails
    );

    const usageOrderSubmission = useSelector(
        (state) => state.reportUsageRootReducer.usageOrderSubmission
    );
    const restrictReviewScreen = useSelector(
        (state) => state.reportUsageRootReducer.restrictReviewScreen
    );

    const isSubmitClicked = useSelector(
        (state) => state.reportUsageRootReducer.isSubmitClicked
    );

    const orderStatus = useSelector(
        (state) => state.reportUsageRootReducer.orderStatus
    );

    const isUsagedSubmittedSuccessfully =
        (usageOrderSubmission && usageOrderSubmission.statusCode === '200') ||
        (Object.keys(orderStatus).length > 0 &&
            orderStatus.status &&
            orderStatus.status.includes('Usage Order Submitted Successfully'));

    const hasVisiblePatientDetails = [
        ['href', patientIdVisibility, storedPatientDetails?.hrefId],
        ['name', patientInformationVisibility, storedPatientDetails?.patientFirstName],
        ['sex', patientInformationVisibility, storedPatientDetails?.patientSex],
        ['dob', patientInformationVisibility, storedPatientDetails?.patientDOB],
    ].some(([field, visibility, value]) =>
        visibility === VISIBLE &&
        reportUsagePatientDetails?.includes(field) &&
        Boolean(String(value ?? '').trim())
    );

    return (
        <>
            {(!fromReportPayment || hasVisiblePatientDetails) && (<>
                <CollapsableCard id="reportUsage-patientInformation-patientInformation-patientInformation"
                    title={
                        title
                            ? title
                            : t('reportUsage.progressBar.PatientInformation')
                    }
                    titleFontSize={SMALL_TEXT_PX}
                    onClick={() =>
                        reportUsagePatientDetails?.length > 0
                            ? toggleCard('patient', !patient)
                            : null
                    }
                    isExpanded={patient}
                    currentActivity={reviewScreen ? false : true}
                    cursor={'pointer'}
                    editButton={
                        isUsagedSubmittedSuccessfully ||
                        isSubmitClicked ||
                        !restrictReviewScreen
                            ? null
                            : showEditButton && edit
                    }
                    editPage={() => navigateToSpecifiedScreen('Record')}
                    margin={fromReportPayment && '10px 0px 10px 0px'}
                    countryCode={countryCode}
                    reportUsagePatientDetails={reportUsagePatientDetails}
                >
                    {patient ? (
                        <>
                            <InfoMainContainer>
                                {storedPatientDetails?.hrefId &&
                                    reportUsagePatientDetails?.includes(
                                        'href'
                                    ) &&
                                    patientIdVisibility === VISIBLE && (
                                        <InfoItems
                                            setMarginBottom={
                                                fromReportPayment ? false : true
                                            }
                                        >
                                            <InfoItemsTitle showAstrisk={false}>
                                                {t(
                                                    'reportUsage.patientDetails.hospitalPatientReferenceId'
                                                )}
                                            </InfoItemsTitle>
                                            <InfoItemsValue
                                                className="report-usage-patient-href-id-dt-mask"
                                                marginBottom={'0px'}
                                            >
                                                {storedPatientDetails.hrefId}
                                            </InfoItemsValue>
                                        </InfoItems>
                                    )}
                                {patientInformationVisibility === VISIBLE && (
                                    <>
                                        {storedPatientDetails?.patientSex &&
                                            reportUsagePatientDetails?.includes(
                                                'sex'
                                            ) && (
                                                <InfoItems
                                                    setMarginBottom={true}
                                                >
                                                    <InfoItemsTitle
                                                        showAstrisk={false}
                                                    >
                                                        {t(
                                                            'reportUsage.patientDetails.patientSex'
                                                        )}
                                                    </InfoItemsTitle>
                                                    <InfoItemsValue className="report-usage-patient-sex-dt-mask">
                                                        {
                                                            storedPatientDetails.patientSex
                                                        }
                                                    </InfoItemsValue>
                                                </InfoItems>
                                            )}
                                        {storedPatientDetails?.patientFirstName &&
                                            reportUsagePatientDetails?.includes(
                                                'name'
                                            ) && (
                                                <InfoItems
                                                    setMarginBottom={true}
                                                >
                                                    <InfoItemsTitle
                                                        showAstrisk={false}
                                                    >
                                                        {t(
                                                            'reportUsage.patientDetails.patientName.title'
                                                        )}
                                                    </InfoItemsTitle>
                                                    <InfoItemsValue className="report-usage-patient-name-dt-mask">
                                                        {
                                                            storedPatientDetails.patientSalutation
                                                        }{' '}
                                                        {
                                                            storedPatientDetails.patientFirstName
                                                        }{' '}
                                                        {
                                                            storedPatientDetails.patientLastName
                                                        }
                                                    </InfoItemsValue>
                                                </InfoItems>
                                            )}
                                        {storedPatientDetails?.patientDOB &&
                                            reportUsagePatientDetails?.includes(
                                                'dob'
                                            ) && (
                                                <InfoItems
                                                    setMarginBottom={true}
                                                >
                                                    <InfoItemsTitle
                                                        showAstrisk={false}
                                                    >
                                                        {t(
                                                            'reportUsage.common.patientInformation.patientDob'
                                                        )}
                                                    </InfoItemsTitle>
                                                    <InfoItemsValue className="report-usage-patient-dob-dt-mask">
                                                        {getDisplayDate(
                                                            storedPatientDetails.patientDOB
                                                        )}
                                                    </InfoItemsValue>
                                                </InfoItems>
                                            )}
                                    </>
                                )}
                            </InfoMainContainer>
                        </>
                    ) : null}
                </CollapsableCard>
            </>
            )}
        </>
    );
};

export default PatientInformation;
